import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SingleSelect from '../../../input_filed/SingleSelect';
import SaveButton from '../../../buttons/SaveButton';
import { useFormik } from 'formik';
import { toast, ToastContainer } from 'react-toastify';
import { Form } from 'react-bootstrap';
import Text from '../../../input_filed/Text';
import { designationSchema } from './ValidationSchema';
import { addDesignationTodo } from '../../../../redux/slices/master/designation/AddDesignation';

export default function AddDesignationForm() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [spiner, setSpiner] = useState(false)

    const status_option = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' }
    ];

    const initiaValues = {
        designation: '',
        status: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initiaValues,
        validationSchema: designationSchema,

        onSubmit: (values, action) => {
            setSpiner(true)
            dispatch(addDesignationTodo(values)).then((res) => designation_res(res))

        }
    })

    const designation_res = (res) => {


        if (res?.payload?.status == 201) {
            toast.success(res?.payload?.data?.message, { position: "bottom-right" });
            setTimeout(() => {
                setSpiner(false);
                navigate('/designation-list')
            }, 1000);
        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
            setSpiner(false);
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
            setSpiner(false);
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
            setSpiner(false);
        } else {
            setSpiner(false);
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }
    return (
        <>

            <Form onSubmit={handleSubmit}>
                <div className='main_layout'>
                    <div className='layout_head mb-3'>
                        <h5>Add Designation</h5>
                    </div>
                    <hr />
                    <div className='row'>
                        <div className='col-md-4'>
                            <Text
                                label_name='Designation'
                                name='designation'
                                value={values.designation}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.designation && touched.designation && <span className='text-danger form_label'>{errors.designation}</span>}
                            />
                        </div>
                        <div className='col-md-4'>
                            <SingleSelect
                                label_name='Status'
                                option={status_option}
                                name='status'
                                onChange={(e) => setFieldValue('status', e.value)}
                                onBlur={handleBlur}
                                error={errors.status && touched.status && <span className='text-danger form_label'>{errors.status}</span>}
                            />
                        </div>
                        <div className='d-flex justify-content-end mt-2'>
                            <SaveButton
                                spiner={spiner}
                                name={'SAVE'}
                            />
                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}
